import { createContext } from 'react';

import { FormState, SignatureState, SubmitReceipt } from 'components/Teleconsent/types';

export type TeleconsentMode = 'guided' | 'selfpaced' | 'follow';

export type CursorPosition = {
  connectionId: string;
  userName: string;
  x: number;
  y: number;
};

export type HostScrollTarget = { sectionId: string; sectionFraction: number };

export type ClientViewport = { width: number; height: number };

export interface ITeleconsentContext {
  isOpen: boolean;
  sessionId: string | null;
  formKey: string | null;
  isHost: boolean;
  mode: TeleconsentMode;
  fields: FormState;
  signature: SignatureState;
  receipt: SubmitReceipt | null;
  cursors: CursorPosition[];
  highlightedBlockId: string | null;
  clientDownloaded: boolean;
  hostScrollTarget: HostScrollTarget | null;
  clientViewport: ClientViewport | null;
  participantName: string | null;
  providerName: string | null;
  clientLabel: string;

  startSession(
    formKey: string,
    participantIdentity: string | null,
    providerPrefill?: Record<string, string>,
    participantDisplayName?: string,
    providerName?: string,
    clientLabel?: string,
  ): Promise<void>;
  submitForm(): Promise<SubmitReceipt>;
  endSession(): void;
  updateField(fieldId: string, value: string | boolean): void;
  updateSignature(dataUrl: string, text: string, kind: 'draw' | 'type'): void;
  moveCursor(x: number, y: number): void;
  focusPosition(sectionId: string, sectionFraction: number): void;
  scrollPosition(sectionId: string, sectionFraction: number): void;
  highlightBlock(blockId: string | null): void;
  setMode(mode: TeleconsentMode): void;
  goBackSignal: number;
  clientEndedSession: boolean;
  notifyDownloaded(): void;
  applySignature(dataUrl: string): void;
  notifyGoBack(): void;
  notifyClientClosed(): void;
  dismissClientEndedSession(): void;
}

export const TeleconsentContext = createContext<ITeleconsentContext | null>(null);
